import * as React from "react";
import "../Styles/style.css";

export default function FrequentlyAskedQuestions() {
  return (
    <>
      <div className="infoMainConatiner py-5">
        <div className="container">
          <h4 className="termsMainHeading">Frequently Asked Questions</h4>

          <div className="infoMainBody p-3">
            <h5 className="fs-4">Log in and Sign up Assistance</h5>
            <br />
            <h5>Login and Member Account Assistance:</h5>
            <p>
              If you registered an account on FameWheel but did not receive the
              activation link on the registered mail address: here are the easy
              steps that can help:
              <br /> <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Check Your Spam Folder:</b>{" "}
              Initially check your spam folders to make sure that the activation
              email didn't go there by some mistake.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Direct Login:</b> Apart from
              this, you can also directly ‘Sing up’ on the top right corner of
              the main page to gain access to your account.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Enter Your Credentials:</b> By
              entering login information i.e. username and password on the
              provided fields, you can access the registered account. <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Resend Activation Email:</b> if
              you see the message on your screen that “Account is not activated”
              or the account hasn't been activated, follow the link labelled
              ‘Re- send Activation Email'. By just clicking on the same, an
              email will be sent to your email address with an activation code
              <br />
            </p>
            <br />

            <h5>Reset Password/Forget Password Assistance</h5>

            <br />
            <p>
              If you've forgotten your password and need to update your email
              address on FameWheels, follow these steps:
            </p>
            <br />
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Access the Login Page:</b>{" "}
              Firstly, direct the user to the domain login page. You can do it
              by clicking on the 'Sign In' link found at the very top right
              corner of the Home Page.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Retrieve Password:</b> The
              'Forgot Password' link is located in the bottom parts of the field
              of entering password. Just click on the link “Forget password”.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Provide Information:</b> The
              Forget Password link directs you to the next step of providing
              information. Just provide your registered email address and click
              on the “Continue” button.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>
                Receive Password Reset Link:
              </b>{" "}
              on the very next step, you will get the password reset mail from
              Fame Wheel, containing a ‘link’ or OTP.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Set New Password:</b> After
              entering OTP, you will see a form that shows up in your browser,
              where you will need to enter your password. Enter your password
              into the field ‘Set New Password’ and confirm it by retyping your
              new password.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Log In:</b> after setting your
              new password, you will get autologin automatically, or you can log
              in through the registered email address and new password on the
              main login page.
              <br />
            </p>
            <br />
            <hr />
            <br />
            <h5>Guidance for Used Car Advertisements:</h5>
            <br />
            <h5>How to Create and Manage Your Car Ad:</h5>
            <p>
              You can follow these below-mentioned steps to post an ad on your
              Car.
              <br /> <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Sign In or Sign Up:</b> First
              sign up to become an account holder on the Fame Wheel, in case you
              do not possess one already. If you have an active account, please
              log in with username/email and password.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Access Selling Options:</b> on
              the main homepage, find the button ‘Sell Your Car’ under the
              drop-down of ‘Used Cars’ on the top left side of the homepage.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Complete the Form:</b> You will
              be required to fill the form correctly and compose detailed data
              regarding your vehicle. When you've finished the task, just do the
              'Submit' button.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Await Approval:</b> Your ad will
              be gone through by our admin team. A confirmation email will be
              sent to you when once we analyse the ad. Your ad would appear then
              among the search results.
              <br />
            </p>
            <br />
            <h5>Why Your Ad is Rejected?</h5>
            <p>
              If a mail states that your used car selling ad has been rejected,
              it might have some reasons; including; <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              <b>Incomplete or Incorrect Information:</b> Your ad might be
              rejected due to false or incomplete information, if you took a
              shortcut to write a title and didn’t provide all the required
              information.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Policy Violations:</b> Ads
              comprising photos or any content that breaches our policy can lead
              to rejection of the ad.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Verification:</b> You might
              reach for the verification of the ad through a phone call, failing
              to connect with you, and then maybe your ad might not have been
              approved.
              <br />
            </p>
            <br />
            <h5>Want to close your ad?</h5>
            <p>
              If you change your mind and do not want to proceed further, here's
              what you need to
              <br /> <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Sign In:</b> Access your
              FameWheels accounts.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>My Ads:</b> Access the menu
              ‘Used Cars’ and click on ‘My Ads’.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Locate Your Ad:</b> locate the
              specific car ad you wish to close with an asterisk on the list.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Confirmation:</b> after clicking
              on the ‘close ad’, the status of the case will be marked to
              ‘Closed’, indicating that the ad is now inactive unless you choose
              to reopen the ad.
              <br />
              <br />
              These instructions you can use to make posting, managing, and then
              closing the used car ad on the electronic platform ‘FameWheels’
              process easy.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
